import React from 'react';
import { ChatResponse, QueryResult } from '../types';

interface QueryResultsProps {
  response: ChatResponse;
  onSendMessage: (message: string) => void;
}

const QueryResults: React.FC<QueryResultsProps> = ({ response, onSendMessage }) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = 'https://via.placeholder.com/300x200?text=Image+Not+Found';
  };

  const openImage = (url: string) => {
    window.open(url, '_blank');
  };

  const handleColorClick = (product_color: string) => {
    onSendMessage(`Search for colors similar to rgb${product_color}`);
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* {(!response.products || response.products.length === 0) ? (
        <div style={{ 
          textAlign: 'center', 
          color: '#999', 
          padding: '50px',
          fontSize: '16px'
        }}>
          No products found per your parameters
        </div>
      ) :  */}
      {(response.products && response.products.length !== 0) && (
        <>
          {/* <div className="search-results-header">
            Found {response.products.length} product{response.products.length !== 1 ? 's' : ''}
          </div> */}
          
          <div className="search-results-products-container">
            {response.products.map((product: QueryResult) => (
              <div 
                key={product.id}
                className="product-card-container"
                // onClick={() => openImage(product.productURL || product.imageURL)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.8) 0px 4px 16px'; //'0 4px 16px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.6) 0px 2px 8px'; //'0 2px 8px rgba(0,0,0,0.1)';
                }}
              >
                <div className="product-card-img-container">
                  <div className='product-card-img-details'>
                    <div className="product-card-img-color-pallette">
                      <div className="color-pallette-colorbox"
                        onClick={() => handleColorClick(product.color1)}
                        style={{ backgroundColor: 'rgb' + product.color1 }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.8) 0px 4px 16px';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.6) 0px 2px 8px';
                        }}/>
                      <div className="color-pallette-colorbox"
                        onClick={() => handleColorClick(product.color2)}
                        style={{ backgroundColor: 'rgb' + product.color2 }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.8) 0px 4px 16px';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.6) 0px 2px 8px';
                        }}/>
                      <div className="color-pallette-colorbox"
                        onClick={() => handleColorClick(product.color3)}
                        style={{ backgroundColor: 'rgb' + product.color3 }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.8) 0px 4px 16px';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          // e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.6) 0px 2px 8px';
                        }}/>                      
                    </div>
                    <img
                      className="product-card-img"
                      src={product.imageURL}
                      alt={product.title}
                      onError={handleImageError}
                      onClick={() => openImage(product.productURL || product.imageURL)}
                      
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                  </div>
                </div>
                
                {/* Product description */}
                <div className="product-card-text-container">
                  <div className="product-card-header">
                    <h3 className="product-card-shop">
                      {product.shopName}
                    </h3>
                    <h3 className="product-card-title">
                      {product.title}
                    </h3>
                  </div>

                  <p className="product-card-description">
                    {product.description}
                  </p>
                  
                  {/* {product.productURL && (
                    <div style={{ 
                      marginTop: '10px', 
                      fontSize: '12px', 
                      color: '#007bff',
                      textDecoration: 'underline'
                    }}>
                      Click to view source
                    </div>
                  )} */}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default QueryResults;